import React from 'react'
import { useQuery } from '@tanstack/react-query'

import { get, queryKeys } from '@mobi/account/Utils'
import { PageStyled } from '@mobi/account/Common/Styles'
import { Spinner } from '@mobi/component-library/Common/Spinner'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'

import type { PrecommitmentResponse } from '@mobi/account/Areas/SignUp/Utils/SignUpApi'
import { precommitmentUrl } from '@mobi/account/Utils'
import { useHostContext } from '@mobi/account/Common/HostContext'
import { AccountHeader } from '@mobi/component-library/Account'

import { BetLimitForm } from './BetLimitForm'

export const BetLimitPage: React.FC = () => {
  const { channel } = useHostContext()
  const { isLoading, isError, data } = useQuery<PrecommitmentResponse>({
    queryKey: [queryKeys.precommitmentDetails],
    queryFn: () => get(precommitmentUrl.precommitmentDetails),
    retry: false,
    refetchOnWindowFocus: false,
  })

  return (
    <>
      {channel === 'mobile' && <PageHeader title='Bet Limit' />}
      <PageStyled>
        {channel === 'desktop' && <AccountHeader alignItems='start' title='Bet limit' />}
        {isLoading ? (
          <Spinner />
        ) : (
          <BetLimitForm precommitmentDetails={data} hasDataFetchFailed={isError} />
        )}
      </PageStyled>
    </>
  )
}
